module.exports = __webpack_public_path__ + "static/media/0248_Medium.26f7cccf.jpg";